export const EVENT_START_TIME = new Date(Date.UTC(2025, 8, 21, 4, 0, 0)) // September is month 8 (0-indexed), 04:00 UTC is 1pm GMT+9
export const EVENT_NAME = "OTK Creator Smash Pickleball Invitational"
export const EVENT_DESCRIPTION = "Who will be crowned the champion?"

// feature flags
export const ENABLE_SHOP = false
export const COLLECT_WALLETS = false
export const ENABLE_FRIEND_CONNECTIONS = true

export const FRIEND_CONNECTION_POINT_REWARD = 1
export const CONNECTION_TERMS = {
    connection: "friend",
    pendingConnection: "friend request",
	connectAction: {
		currentTense: "share",
		pastTense: "shared details"
	},
	connectedAt: "You became friends"
}

export const POINTS_NAME: "tickets" | "points" = "points"

export const APP_BACKGROUND_IMAGE = "/images/kick-otk-bg.png"
export const APP_LOGO_IMAGE = "/images/logo.svg"

export const THRESHOLD_100_PROGRESS_IMAGE = "/images/100-percent-progress.png"
export const THRESHOLD_NO_PROGRESS_IMAGE = undefined
export const THRESHOLD_PRIZE_PICKUP_LOCATION = "badbad booth"

export const CHANNELS = [
  { name: "instagram", label: "Instagram" },
	{ name: "twitter", label: "Twitter" },
	{ name: "telegram", label: "Telegram" },
] as const

export function getSocialChannelUrl(
	handle: string,
	channelName: string,
): string {
	switch (channelName) {
		case "twitter":
			return `https://twitter.com/${handle}`
		case "telegram":
			return `https://t.me/${handle}`
		case "instagram":
			return `https://instagram.com/${handle}`
		default:
			console.warn(`missing social channel url config for: ${channelName}`)
			return ""
	}
}
